<!-- Собирает визуальную панель данных из готового backend-состояния и доменных секций. -->
<template>
  <section v-if="group && details" class="edo-title-details-panel">
    <EdoDocumentTitleDetailsHeader
      :label="group.label || details.label"
      :role="group.participant_label || group.participant?.label || details.role"
      :title="details.title"
      :status-label="group.status_label"
      :status-variant="statusVariant"
      :show-help="helpItems.length > 0"
      :actions="actions"
      @action="$emit('action', $event)"
      @close="$emit('close')"
      @show-help="helpVisible = true"
    />

    <div v-if="details.hasData !== false" class="edo-title-details-panel__sections">
      <EdoDocumentTitleDataSection
        v-for="section in details.sections"
        :key="section.key"
        :section="section"
      >
        <EdoDocumentRouteTimeline
          v-if="section.routePoints && section.routePoints.length"
          :points="section.routePoints"
        />
      </EdoDocumentTitleDataSection>
    </div>

    <EdoDocumentTitleEmptyState
      v-else
      :title="details.emptyState?.title || 'Данные титула пока отсутствуют'"
      :description="details.emptyState?.description || ''"
      :fields="details.emptyState?.fields || []"
    />

    <footer v-if="navigation" class="edo-title-details-panel__footer">
      <base-button
        variant="secondary"
        icon="chevronLeft"
        type="button"
        :disabled="!navigation.previous"
        @click="selectNavigationTitle(navigation.previous)"
      >
        <template v-if="navigation.previous">
          {{ navigation.previous.label }}<span
            v-if="navigation.previous.role"
            class="edo-title-details-panel__navigation-role"
          > · {{ navigation.previous.role }}</span>
        </template>
        <template v-else>Начало</template>
      </base-button>
      <span v-if="navigation.label" class="edo-title-details-panel__position">
        {{ navigation.label }}
      </span>
      <base-button
        variant="secondary"
        right-icon="chevronRight"
        type="button"
        :disabled="!navigation.next"
        @click="selectNavigationTitle(navigation.next)"
      >
        <template v-if="navigation.next">
          {{ navigation.next.label }}<span
            v-if="navigation.next.role"
            class="edo-title-details-panel__navigation-role"
          > · {{ navigation.next.role }}</span>
        </template>
        <template v-else>Конец</template>
      </base-button>
    </footer>

    <EdoDocumentTitleHelpModal
      :visible="helpVisible"
      :items="helpItems"
      :initial-key="group.key"
      @close="helpVisible = false"
    />

  </section>
</template>

<script>
import EdoDocumentRouteTimeline from "@/components/Edo/shared/EdoDocumentRouteTimeline.vue";
import EdoDocumentTitleDataSection from "@/components/Edo/shared/EdoDocumentTitleDataSection.vue";
import EdoDocumentTitleDetailsHeader from "@/components/Edo/shared/EdoDocumentTitleDetailsHeader.vue";
import EdoDocumentTitleEmptyState from "@/components/Edo/shared/EdoDocumentTitleEmptyState.vue";
import EdoDocumentTitleHelpModal from "@/components/Edo/shared/EdoDocumentTitleHelpModal.vue";

export default {
  name: "EdoDocumentTitleDetailsPanel",

  components: {
    EdoDocumentRouteTimeline,
    EdoDocumentTitleDataSection,
    EdoDocumentTitleDetailsHeader,
    EdoDocumentTitleEmptyState,
    EdoDocumentTitleHelpModal,
  },

  emits: ["action", "close", "select-title"],

  props: {
    // group содержит только готовое состояние процесса из document_flow.
    group: {
      type: Object,
      required: true,
    },
    // details содержит только данные и тексты доменного титула.
    details: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    navigation: {
      type: Object,
      default: null,
    },
    helpItems: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      helpVisible: false,
    };
  },

  computed: {
    // BaseBadge называет нейтральный вариант default, остальные backend-тональности совпадают.
    statusVariant() {
      const tone = this.group.tone || "neutral";
      return tone === "neutral" ? "default" : tone;
    },
  },

  methods: {
    selectNavigationTitle(title) {
      if (title) this.$emit("select-title", title);
    },
  },
};
</script>

<style scoped>
.edo-title-details-panel {
  overflow: hidden;
  border: 1px solid #e3e6ee;
  border-top: 0;
  border-radius: 0 0 16px 16px;
  background: #fff;
  color: var(--color-dark);
}

.edo-title-details-panel__sections {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 32px;
  padding: 8px 24px 24px;
}

.edo-title-details-panel__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 24px;
  border-top: 1px solid #eef0f5;
  background: #fafbfd;
}

.edo-title-details-panel__footer :deep(.btn:disabled) {
  opacity: 0.6;
}

.edo-title-details-panel__position {
  color: #5b6070;
  font-size: 13px;
  text-align: center;
}

@media (max-width: 720px) {
  .edo-title-details-panel__sections {
    grid-template-columns: minmax(0, 1fr);
    padding: 4px 14px 20px;
  }

  .edo-title-details-panel__footer {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding: 12px 14px;
  }

  .edo-title-details-panel__position {
    display: none;
  }

  .edo-title-details-panel__navigation-role {
    display: none;
  }

  .edo-title-details-panel__footer > :first-child,
  .edo-title-details-panel__footer > :last-child {
    min-height: 40px;
    height: 40px;
    width: 100%;
  }
}
</style>
